import { EditorContent, Editor as ReactEditor } from '@tiptap/react';
import cx from 'classnames';
import _ from 'lodash';
import { ReactNode } from 'react';
import {
  IRichTextEditorContext,
  RichTextEditorContext,
  useRichTextEditorContext,
} from './context';
import { FootnoteList, IFootnoteListProps } from './FootnoteList';
import { IUseRichTextEditorParams, useRichTextEditor } from './hooks';
import { IMenuProps, Menu } from './Menu';
import css from './RichTextEditor.module.scss';

interface IRichTextEditorProps extends IUseRichTextEditorParams {
  children: ReactNode | ((context: IRichTextEditorContext) => ReactNode);
}

const RichTextEditor = ({
  children,
  defaultTextAlignment,
  maxLength,
  onChange,
  placeholder,
  value,
}: IRichTextEditorProps) => {
  const { editor, id } = useRichTextEditor({
    defaultTextAlignment,
    maxLength,
    onChange,
    placeholder,
    value,
  });

  if (!editor) {
    return null;
  }

  const contextValues: IRichTextEditorContext = {
    editor,
    id,
  };

  return (
    <RichTextEditorContext.Provider value={contextValues}>
      {_.isFunction(children) ? children(contextValues) : children}
    </RichTextEditorContext.Provider>
  );
};

interface IContentProps {
  className?: string;
  isInvalid?: boolean;
}

const Content = ({ className, isInvalid }: IContentProps) => {
  const { editor, id } = useRichTextEditorContext();
  return (
    <EditorContent
      id={id}
      className={cx(css.tiptapEditor, className, { [css.invalid]: isInvalid })}
      editor={editor as ReactEditor}
    />
  );
};

RichTextEditor.Content = Content;
RichTextEditor.Menu = Menu;
RichTextEditor.FootnoteList = FootnoteList;

export { RichTextEditor };
export type {
  IFootnoteListProps as IRichTextEditorFootnoteListProps,
  IMenuProps as IRichTextEditorMenuProps,
  IRichTextEditorProps,
};
